import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import { UserService } from './user.service';
import { map } from 'rxjs/operators/map';
import { take } from 'rxjs/operators/take';
import {Inject, Injectable} from '@angular/core';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor( private router: Router,
                 private userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.userService.isAuthenticated.pipe(take(1), map(isAuth => {
          if (!isAuth) {
                this.router.navigate(['/login']);
            }
            return isAuth;
        }));

    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/auth.guard.ts